<mat-form-field [appearance]="appearance()" class="w-100">
  <mat-label>{{ label() }}</mat-label>
  <mat-select [formControl]="selectedControl" [compareWith]="comparePeriods">

    <!-- Buscador dentro del select -->
    <mat-option>
      <ngx-mat-select-search
        [formControl]="searchControl"
        placeholderLabel="Buscar período..."
        noEntriesFoundLabel="Sin resultados">
      </ngx-mat-select-search>
    </mat-option>

    @if (allowNull()) {
      <mat-option [value]="null">Todos</mat-option>
    }

    @for (period of filteredPeriods(); track period.label) {
      <mat-option [value]="period">{{ period.label }}</mat-option>
    }

  </mat-select>
</mat-form-field>
